export default __webpack_public_path__ + "static/img/xevant-logo-2021.754e5c49b239c8f3119abb3e499a5edf.png";